import React from 'react';

import styles from './logstyles.module.scss';

interface InfoRowProps {
  label: string;
  value?: string | number | null;
  mono?: boolean;
}

const InfoRow = ( { label, value, mono = false }: InfoRowProps ) => (
  <div className={ styles.infoRow }>
    <span className={ styles.infoLabel }>{label}</span>
    <span className={ mono ? styles.infoValueMono : styles.infoValue }>
      {value ?? <span className={ styles.nullValue }>null</span>}
    </span>
  </div>
);

export default InfoRow;